export const CHARACTER_GROUPS = [
  {
    id: "bosque",
    label: "Animales del bosque",
    emoji: "🦁",
    items: [
      { id: "zorro", label: "Zorro curioso", emoji: "🦊" },
      { id: "oso", label: "Oso dormilón", emoji: "🐻" },
      { id: "conejo", label: "Conejo saltarín", emoji: "🐰" },
      { id: "buho", label: "Búho sabio", emoji: "🦉" },
      { id: "ardilla", label: "Ardilla traviesa", emoji: "🐿️" },
      { id: "cervatillo", label: "Cervatillo dulce", emoji: "🦌" },
    ],
  },
  {
    id: "magicas",
    label: "Criaturas mágicas",
    emoji: "🧚",
    items: [
      { id: "hada", label: "Hada de la luna", emoji: "🧚" },
      { id: "dragon", label: "Dragón pequeñín", emoji: "🐉" },
      { id: "unicornio", label: "Unicornio brillante", emoji: "🦄" },
      { id: "duende", label: "Duende del bosque", emoji: "🧝" },
      { id: "mago", label: "Mago aprendiz", emoji: "🧙" },
      { id: "fenix", label: "Pequeño fénix", emoji: "🔥" },
    ],
  },
  {
    id: "heroes",
    label: "Héroes y aventureros",
    emoji: "🚀",
    items: [
      { id: "astronauta", label: "Astronauta valiente", emoji: "🧑‍🚀" },
      { id: "pirata", label: "Pirata bondadoso", emoji: "🏴‍☠️" },
      { id: "caballero", label: "Caballero amable", emoji: "🛡️" },
      { id: "explorador", label: "Exploradora intrépida", emoji: "🧭" },
      { id: "robot", label: "Robot amigable", emoji: "🤖" },
      { id: "cientifico", label: "Pequeña científica", emoji: "🔬" },
    ],
  },
  {
    id: "mascotas",
    label: "Mascotas",
    emoji: "🐾",
    items: [
      { id: "perro", label: "Perro juguetón", emoji: "🐶" },
      { id: "gato", label: "Gato dormilón", emoji: "🐱" },
      { id: "hamster", label: "Hámster valiente", emoji: "🐹" },
      { id: "tortuga", label: "Tortuga lenta", emoji: "🐢" },
      { id: "pez", label: "Pez dorado", emoji: "🐠" },
      { id: "loro", label: "Loro parlanchín", emoji: "🦜" },
    ],
  },
];

export const SCENARIOS = [
  { id: "castillo", label: "Castillo en las nubes", emoji: "🏰" },
  { id: "bosque", label: "Bosque encantado", emoji: "🌲" },
  { id: "oceano", label: "Fondo del mar", emoji: "🌊" },
  { id: "espacio", label: "Galaxia de estrellas", emoji: "🌌" },
  { id: "ciudad_nubes", label: "Ciudad de nubes", emoji: "☁️" },
  { id: "desierto", label: "Desierto luminoso", emoji: "🏜️" },
  { id: "iglu", label: "Iglú polar", emoji: "🧊" },
  { id: "jardin", label: "Jardín secreto", emoji: "🌸" },
];

export const TONES = [
  {
    id: "calm",
    label: "Muy tranquilo",
    emoji: "😴",
    hint: "Para dormirse rápido",
  },
  {
    id: "adventure",
    label: "Aventura suave",
    emoji: "🌟",
    hint: "Descubrimiento luminoso",
  },
  {
    id: "funny",
    label: "Divertido y tonto",
    emoji: "😂",
    hint: "Risas antes de dormir",
  },
];

export const AGE_GROUPS = [
  { id: "0-3", emoji: "👶", label: "0–3 años", hint: "Frases cortas y onomatopeyas" },
  { id: "4-6", emoji: "🧒", label: "4–6 años", hint: "Cuento con moraleja clara" },
  { id: "7-9", emoji: "👦", label: "7–9 años", hint: "Suspense suave y descripción" },
  { id: "10-12", emoji: "🧑", label: "10–12 años", hint: "Narrativa elaborada con giros" },
];

export const LENGTHS = [
  { id: "short", label: "Cortito", emoji: "⏱️", hint: "≈ 3 min" },
  { id: "normal", label: "Normal", emoji: "🕐", hint: "≈ 5 min" },
  { id: "long", label: "Largo", emoji: "🌙", hint: "≈ 10 min" },
];
